angular.module('storefrontApp')
    .directive('vcContentPlace', ['$compile', 'marketingService', function ($compile, marketingService) {
        return {
            restrict: 'E',
            link(scope, element, attrs) {
                marketingService.getDynamicContent(attrs.id)
                    .then((response) => {
                        element.html($compile(response.data)(scope));
                    });
            },
            replace: true,
        };
    }])

    .directive('fallbackSrc', () => ({
        link(scope, element, attrs) {
            element.on('error', errorHandler);

            scope.$on('$destroy', () => {
                element.off('error', errorHandler);
            });

            function errorHandler(event) {
                if (element.attr('src') !== attrs.fallbackSrc) {
                    element.attr('src', attrs.fallbackSrc);
                } else {
                    element.off(event);
                }
            }
        },
    }))

    .directive('easyZoom', () => ({
        restrict: 'A',
        scope: {
            url: '=',
        },
        link(scope, element) {
            scope.$watch('url', () => {
                if (scope.easyZoomApi != null) {
                    scope.easyZoomApi.teardown();
                    scope.easyZoomApi._init(); // eslint-disable-line no-underscore-dangle
                } else {
                    const easyZoom = angular.element(element).easyZoom();
                    scope.easyZoomApi = easyZoom.data('easyZoom');
                }
            });
        },
    }))

    .directive('strictReservedSymbols', () => {
        const isValid = function (viewValue) {
            const reg = /[#$~!`%^&*)(+=|[\]\\:"<>?/{};,]+/;
            return (viewValue || '').match(reg) == null;
        };

        return {
            restrict: 'A',
            require: 'ngModel',
            link(scope, elm, attrs, ngModelCtrl) {
                ngModelCtrl.$parsers.unshift((viewValue) => {
                    ngModelCtrl.$setValidity('strictReservedSymbols', isValid(viewValue));
                    return viewValue;
                });

                ngModelCtrl.$formatters.unshift((modelValue) => {
                    ngModelCtrl.$setValidity('strictReservedSymbols', isValid(modelValue));
                    return modelValue;
                });
            },
        };
    })

    // WCAG-adjacent, and the half the announcement in busyService cannot cover:
    // the busy overlay blocks the MOUSE (a fixed, opaque, z-index 9999 sibling)
    // and nothing else. Measured on QA 2026-09-15 with the overlay held up:
    // every control behind it -- #Email, the shipping-method radios, the step
    // markers, all 20 header and footer stops tested -- was still a tab stop,
    // each one reporting the overlay as the element a mouse would hit. A
    // keyboard could operate what a mouse could not, which is how a customer
    // races an address validation.
    //
    // inert rather than a hand-rolled focus trap: one property takes the whole
    // subtree out of the tab order, out of hit-testing and out of the
    // accessibility tree, and it cannot drift out of date the way a list of
    // ng-disabled terms does (the billing address form is missing that term
    // today -- cart.liquid:363 against :292).
    //
    // WHERE FOCUS ACTUALLY GOES, measured locally 2026-09-15 on the real
    // debounced address path (probes/1003-focus-trace.mjs) -- the first version
    // of this directive restored one captured node and that was not enough:
    //      +0ms  focus on a shipping-method RADIO. The 800ms debounce
    //            ($checkout.js:1114) means the customer has normally tabbed past
    //            the address by the time validation starts.
    //   +1342ms  block; focus parked on #rs-busy-status.
    //   +2451ms  released; focus STILL on #rs-busy-status -- the radio it was
    //            told to restore no longer existed.
    //     then   Tab -> Live Chat -> body -> "Skip to main content": the walk
    //            resumes at the TOP OF THE PAGE. That is the reported symptom.
    // The radio is gone because getAvailShippingMethods() rebuilds the whole
    // ng-repeat WHILE the block is up (checkout-shippingMethods.js:70-73), so
    // the node is detached before there is anything to hand it back to. Hence
    // the anchor below is a node AND its ancestor chain, and Tab is pinned.
    .directive('rsBusyBlock', [
        '$document', '$timeout', 'focusService', 'busyService',
        function ($document, $timeout, focusService, busyService) {
            const doc = $document[0];
            const region = () => doc.getElementById('rs-busy-status');

            // Attached, enabled and actually rendered. offsetParent is the cheap
            // visibility test: inside an ng-show'd-away ancestor .focus() is a
            // no-op and would leave focus on <body>.
            function restorable(node) {
                return !!node && doc.contains(node) && !node.disabled && node.offsetParent !== null;
            }

            function chainOf(node) {
                const chain = [];

                for (let el = node; el && el !== doc.body; el = el.parentElement) {
                    chain.push(el);
                }

                return chain;
            }

            return {
                restrict: 'A',
                link(scope, element) {
                    // Captured at block time: the focused node, its id, and its
                    // ancestor chain. The chain is the half that survives a
                    // re-render -- for a replaced radio the nearest surviving
                    // ancestor is the radiogroup wrapper, i.e. the delivery
                    // options, which is where the customer was standing.
                    let anchor = null;
                    let restoreTimer = null;

                    // Same id beats same position: the shipping-method radios are
                    // rebuilt carrying identical ids (method.id,
                    // checkout-shippingMethods.js:33), so this puts the customer back
                    // on the option they were on rather than merely near it. The
                    // chain is the fallback, and its first entry is the original
                    // node -- so a form field that was never re-rendered (the phone
                    // input, the email) is matched there and restored exactly.
                    function resolve() {
                        if (!anchor) {
                            return null;
                        }

                        if (anchor.id) {
                            const byId = doc.getElementById(anchor.id);

                            if (restorable(byId)) {
                                return byId;
                            }
                        }

                        return anchor.chain.find(restorable) || null;
                    }

                    // Tab stays on the busy region while the block is up. Everything
                    // it could otherwise reach is either inert (#layout) or useless
                    // while it is -- the skip link points INTO the inert subtree --
                    // so letting the walk run only means it resumes at the top of the
                    // page. A deliberate, BOUNDED trap: busyService lifts the block
                    // after 20s whether the operation finished or not, and that valve
                    // is the way out of a hung request. It costs the keyboard route
                    // to the chat widget for those 20s, which is the price of not
                    // losing the customer's place in the form.
                    function onKeydown(event) {
                        if (event.key !== 'Tab') {
                            return;
                        }

                        const active = doc.activeElement;
                        const r = region();

                        // Unless something outside the blocked subtree has taken
                        // focus for itself. The address-suggestion dialog opens
                        // while the block is still lifting ($checkout.js:359 --
                        // the rejection that ends it is raised immediately after)
                        // and it owns its own tab order; swallowing Tab inside it
                        // would be the trap this is meant to prevent.
                        if (active && active !== r && active !== doc.body) {
                            return;
                        }

                        event.preventDefault();

                        if (r && active !== r) {
                            r.focus();
                        }
                    }

                    function block() {
                        const active = doc.activeElement;

                        // Never overwrite an anchor that has not been handed back
                        // yet. A second operation can begin before the restore runs
                        // -- updateShipment's success path loads the shipping options
                        // -- and re-capturing there would remember the parked region
                        // itself, which is how focus stays at the top.
                        if (!anchor && element[0].contains(active)) {
                            anchor = { id: active.id || null, chain: chainOf(active) };
                        }

                        $timeout.cancel(restoreTimer);
                        element[0].inert = true;

                        // Park focus outside the blocked subtree. The region is still
                        // EMPTY at this moment -- busyService holds the text back
                        // 300ms -- so landing on it announces nothing and the live
                        // region does the talking a beat later. Without this, inert
                        // drops focus to <body> exactly as the disabled continue
                        // button already did: 60 Tab presses from there never reached
                        // the form again (the header and mega-menu are in the way).
                        const r = region();

                        if (r) {
                            r.focus();
                        }

                        $document.on('keydown', onKeydown);
                    }

                    function restore() {
                        // ONLY if nothing else claimed focus. Both address paths
                        // deliberately move it -- to the refused-address message or
                        // to the next step's heading -- and taking it back would
                        // undo that.
                        if (doc.activeElement !== region()) {
                            anchor = null;

                            return;
                        }

                        // #main-content is the floor when there is nothing to go back
                        // to (focus was on <body>, or every candidate is gone): still
                        // not where the customer was, but inside the page rather than
                        // above it, so Tab continues into the step and not the header.
                        focusService.focusRegion(resolve() || 'main-content');

                        // The re-render normally lands DURING the block, but it does
                        // not have to. Arriving just after the restore detaches the
                        // node again and drops focus to <body>; re-resolving from the
                        // same chain is the only way to catch that. Guarded on <body>
                        // so a deliberate move by anything else is left alone.
                        restoreTimer = $timeout(function () {
                            if (doc.activeElement === doc.body) {
                                focusService.focusRegion(resolve() || 'main-content');
                            }

                            anchor = null;
                        }, 250);
                    }

                    function unblock() {
                        element[0].inert = false;
                        $document.off('keydown', onKeydown);

                        // One tick: inert has to be off before anything in the
                        // subtree can take focus at all.
                        restoreTimer = $timeout(restore, 50);
                    }

                    scope.$on('$destroy', function () {
                        $document.off('keydown', onKeydown);
                        $timeout.cancel(restoreTimer);
                    });

                    scope.$watch(function () {
                        return busyService.blocked;
                    }, function (blocked, wasBlocked) {
                        if (blocked === wasBlocked) {
                            return;
                        }

                        if (blocked) {
                            block();
                        } else {
                            unblock();
                        }
                    });
                },
            };
        },
    ])

    .directive('initFromForm', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link(scope, element, attrs) {
                const attr = attrs.initFromForm || attrs.ngModel || element.attrs('name');
                let val = attrs.value;

                if (attrs.type === 'number') {
                    val = parseInt(val, 10);
                }

                $parse(attr).assign(scope, val);
            },
        };
    }]);
